import { render, staticRenderFns } from "./SithMesPrdProjectPlanDetailPpdList.vue?vue&type=template&id=6af12f58&"
import script from "./SithMesPrdProjectPlanDetailPpdList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdProjectPlanDetailPpdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports